import { useRecoilCallback, useRecoilState, useRecoilValue } from "recoil";
import { useState, useEffect } from "react";
import { ServiceWaitList } from "src/services/agenda/waitlist";
import {
  professionalsFetchState,
  professionalsWaitListState,
  specialityWaitListState,
} from "../state/atoms";
import { dayDefaultAvailableState } from "src/SearchHours/components/calendars/state/atoms";
import useCatchErrorApi from "src/shared/hooks/useCatchErrorApi";

export const useProfessionals = () => {
  const { catchErrorApi } = useCatchErrorApi();
  const [professionals, setProfessionals] = useRecoilState(
    professionalsWaitListState
  );
  const [specialitySelected] = useRecoilState(specialityWaitListState);
  const dayDefaultAvailable = useRecoilValue(dayDefaultAvailableState);

  const [loading, setLoading] = useState(false);

  const loadProfessionals = useRecoilCallback(
    ({ snapshot }) =>
      async () => {
        setLoading(true);
        try {
          let especialidadCode = specialitySelected.code;
          const professionalsFetch = await snapshot.getPromise(
            professionalsFetchState(especialidadCode, dayDefaultAvailable)
          );

          const responses = await Promise.all([professionalsFetch]);

          setProfessionals(responses[0]);
        } catch (error) {
          catchErrorApi(error);
        } finally {
          setLoading(false);
        }
      },
    [dayDefaultAvailable, specialitySelected]
  );

  useEffect(() => {
    loadProfessionals();
  }, [specialitySelected, loadProfessionals]);

  return { professionals, loading, loadProfessionals };
};
